'use strict';
import EventInitializer from './helper/EventInitializer';
import EventBinder from './helper/EventBinder';
class ExternalTracker {
    constructor(tracker, config) {
        this.debugMethod = (_message) => { };
        this.tracker = tracker;
        this.debugMethod = config.debug === true ? (message, ...args) => console.debug('Zoovu Search Tracking:', message, ...args) : () => { };
        if (config.debug === true) {
            tracker.setDebugMethod(this.debugMethod);
        }
        this.binder = new EventBinder(this.tracker, this.debugMethod);
        this.config = config;
        this.bindSearchBox();
        this.bindSuggestBox();
        this.bindSerp();
        this.bindAddToCart();
        this.bindCheckout();
    }
    callInitCallback(callback) {
        if (callback !== undefined && callback !== null) {
            try {
                callback(this.tracker, this.binder);
            }
            catch (err) {
                // ccl
            }
        }
    }
    bindSearchBox() {
        const searchBoxConfig = this.config.searchBox;
        if (!searchBoxConfig) {
            this.debugMethod('No search box configuration provided');
            return;
        }
        const suggestBoxConfig = this.config.searchSuggestions;
        this.debugMethod('Initializing search box events');
        EventInitializer.bind(searchBoxConfig.initializationStrategy, () => {
            const suggestBlockSelector = suggestBoxConfig ? suggestBoxConfig.blockSelector : undefined;
            const suggestItemSelector = suggestBoxConfig ? suggestBoxConfig.itemSelector : undefined;
            const suggestActiveItemSelector = suggestBoxConfig ? suggestBoxConfig.activeItemSelector : undefined;
            const articleNumberSource = suggestBoxConfig ? suggestBoxConfig.articleNumberSource : undefined;
            const identifierSource = suggestBoxConfig ? suggestBoxConfig.identifierSource : undefined;
            this.binder.bindSearchBoxEvents(searchBoxConfig.selector, searchBoxConfig.button, suggestBlockSelector, suggestItemSelector, suggestActiveItemSelector, articleNumberSource, identifierSource, searchBoxConfig.trackSubmitOnly, searchBoxConfig.ignoreForms);
            this.callInitCallback(searchBoxConfig.initCallback);
        });
    }
    bindSuggestBox() {
        const suggestBoxConfig = this.config.searchSuggestions;
        if (!suggestBoxConfig) {
            this.debugMethod('No suggest box configuration provided');
            return;
        }
        this.debugMethod('Initializing suggest box events');
        EventInitializer.bind(suggestBoxConfig.initializationStrategy, () => {
            this.binder.bindSuggestBoxEvents(suggestBoxConfig.blockSelector, suggestBoxConfig.itemSelector, (this.config.searchBox || {}).selector, suggestBoxConfig.articleNumberSource, suggestBoxConfig.identifierSource, suggestBoxConfig.addToCartTrigger, suggestBoxConfig.countSource, suggestBoxConfig.priceSource, suggestBoxConfig.priceUnitSource);
            this.callInitCallback(suggestBoxConfig.initCallback);
        });
    }
    bindSerp() {
        const serpConfig = this.config.searchResults;
        if (!serpConfig) {
            this.debugMethod('No search result page configuration provided');
            return;
        }
        this.debugMethod('Initializing search result page events');
        EventInitializer.bind(serpConfig.initializationStrategy, () => {
            this.binder.bindSerpEvents(serpConfig.expectedConditions, serpConfig.querySource, serpConfig.blockSelector, serpConfig.itemSelector, serpConfig.excludeActiveSelector, serpConfig.singleGroupSelector, serpConfig.articleNumberSource, serpConfig.identifierSource, serpConfig.addToCartTrigger, serpConfig.countSource, serpConfig.priceSource, serpConfig.priceUnitSource, serpConfig.unbindAbandonSelector, serpConfig.rebindStrategy);
            this.callInitCallback(serpConfig.initCallback);
        });
    }
    bindAddToCart() {
        const cartConfig = this.config.productDetailPage;
        if (!cartConfig) {
            this.debugMethod('No add to cart configuration provided');
            return;
        }
        this.debugMethod('Initializing add to cart events');
        EventInitializer.bind(cartConfig.initializationStrategy, () => {
            this.binder.bindCartEvents(cartConfig);
            this.callInitCallback(cartConfig.initCallback);
        });
    }
    bindCheckout() {
        const checkoutConfig = this.config.checkout;
        if (!checkoutConfig) {
            this.debugMethod('No checkout configuration provided');
            return;
        }
        this.debugMethod('Initializing checkout events');
        EventInitializer.bind(checkoutConfig.initializationStrategy, () => {
            this.binder.bindCheckoutEvents(checkoutConfig);
            this.callInitCallback(checkoutConfig.initCallback);
        });
    }
    unbindAll() {
        this.binder.unbindAll();
    }
}
export default ExternalTracker;
